import React from 'react';
import SEO from '../../components/SEO/SEO';
import SubServiceTemplate from '../../components/SubServiceTemplate/SubServiceTemplate';

const OffPageSEO = () => {
  const pageData = {
    category: "OFF-PAGE SEO",
    title: "Off-Page SEO & Authority Building",
    description: "Build authority and trust through strategic digital PR, guest posting, and quality backlink acquisition. Our off-page SEO strategies establish your brand as an industry leader.",
    ctaText: "Get a Free SEO Audit",
    ctaLink: "/contact",
    parentLink: "/services/seo",
    parentTitle: "SEO",

    features: [
      {"icon": "📰", "title": "Digital PR & Guest Posting", "description": "High-quality guest posts on authoritative industry publications."},
      {"icon": "🔗", "title": "Backlink Outreach", "description": "White-hat link building campaigns with relevant, high-authority sites."},
      {"icon": "🏆", "title": "Brand Mentions", "description": "Build brand awareness through strategic mentions and citations."},
      {"icon": "🤝", "title": "Content Collaboration", "description": "Partner with industry influencers for content amplification."},
      {"icon": "📈", "title": "Authority Growth", "description": "Systematic domain authority improvement through quality signals."},
      {"icon": "🛡️", "title": "Reputation Management", "description": "Monitor and manage your online reputation across platforms."}
    ],

    benefits: [
      {
        title: "Higher Search Rankings",
        description: "Achieve top positions for your target keywords and dominate search results."
      },
      {
        title: "Increased Organic Traffic",
        description: "Drive more qualified visitors to your website without paying for ads."
      },
      {
        title: "Better User Experience",
        description: "Optimizations that benefit both search engines and your users."
      },
      {
        title: "Measurable ROI",
        description: "Track rankings, traffic, and conversions with detailed reporting."
      }
    ],

    process: [
      {
        title: "Audit & Analysis",
        description: "Comprehensive analysis of current performance and opportunities."
      },
      {
        title: "Strategy Development",
        description: "Custom roadmap tailored to your business goals and market."
      },
      {
        title: "Implementation",
        description: "Execute optimizations with precision and best practices."
      },
      {
        title: "Monitor & Refine",
        description: "Continuous tracking and optimization for maximum results."
      }
    ],

    whyChoose: {
      title: "Expert SEO Specialists",
      description: "Our team has years of experience delivering results across industries. We follow white-hat practices and stay updated with the latest algorithm changes.",
      points: [
        {
          title: "Proven Track Record",
          description: "300%+ average traffic increase for our clients"
        },
        {
          title: "Transparent Reporting",
          description: "Monthly reports with clear KPIs and actionable insights"
        },
        {
          title: "Dedicated Support",
          description: "Direct access to your SEO specialist and account manager"
        }
      ]
    },

    relatedServices: [
      {"icon": "🔗", "title": "Link Building", "description": "Dedicated link acquisition strategies", "link": "/services/seo/link-building"},
      {"icon": "📝", "title": "On-Page SEO", "description": "Content and structure optimization", "link": "/services/seo/on-page"},
      {"icon": "⚙️", "title": "Technical SEO", "description": "Technical site optimization", "link": "/services/seo/technical-seo"}
    ]
  };

  return (
    <>
      <SubServiceTemplate {...pageData} />
      
            <SEO 
                title="Off Page S E O Services" 
                description="Learn more about our Off Page S E O services to grow your business online with Digi Network." 
                canonical="/seo/off-page-seo" 
            />

    </>
  );
};

export default OffPageSEO;
